import {
  type AppLocale,
  localeUsesRuRegionalFormat,
} from "@/shared/i18n/translations"

export function toMilliseconds(ts: number): number {
  return ts < 1e12 ? ts * 1000 : ts
}

function parseCreatedAt(createdAt: string | number | null | undefined): Date | null {
  if (createdAt == null || createdAt === "") return null
  if (typeof createdAt === "number") {
    const ms = toMilliseconds(createdAt)
    const date = new Date(ms)
    return Number.isNaN(date.getTime()) ? null : date
  }
  const asNumber = Number(createdAt)
  if (Number.isFinite(asNumber) && /^\d+(\.\d+)?$/.test(createdAt.trim())) {
    const date = new Date(toMilliseconds(asNumber))
    return Number.isNaN(date.getTime()) ? null : date
  }
  const date = new Date(createdAt)
  return Number.isNaN(date.getTime()) ? null : date
}

/** Today / Yesterday / DD.MM.YYYY, HH:mm — same rules as legit-check header. */
export function formatPvpRoundDisplayDate(
  createdAt: string | number | null | undefined,
  locale: AppLocale,
  t: (path: string, params?: Record<string, string | number>) => string,
  now: Date = new Date()
): string {
  const date = parseCreatedAt(createdAt)
  if (!date) return ""

  const time = date.toLocaleTimeString(
    localeUsesRuRegionalFormat(locale) ? "ru-RU" : "en-GB",
    {
      hour: "2-digit",
      minute: "2-digit",
    }
  )

  const todayMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const yesterdayMidnight = new Date(todayMidnight.getTime() - 86_400_000)
  const dateMidnight = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  )

  if (dateMidnight.getTime() === todayMidnight.getTime())
    return `${t("history.today")}, ${time}`
  if (dateMidnight.getTime() === yesterdayMidnight.getTime())
    return `${t("history.yesterday")}, ${time}`

  const day = String(date.getDate()).padStart(2, "0")
  const month = String(date.getMonth() + 1).padStart(2, "0")
  const year = date.getFullYear()
  return `${day}.${month}.${year}, ${time}`
}
